module.exports = __webpack_public_path__ + "img/gepuzemeltetesi_elorejelzes_es_adat_elemzesek.cc016273.png";